import { FC } from "react";
import WW from "../../assets/wounded_warrior.gif";
import ESGR from "../../assets/esgr_logo.jpg";
import HVF from "../../assets/hirevetsfirst_logo.jpg";
import "./Careers.scss";

export const Careers: FC = () => {
  return (
    <div className="Careers">
      <div className="Careers__header page-header">
        <h1>Careers</h1>
        <p>
          Our workforce is well educated, certified, accomplished, and
          experienced to meet the challenges and fast pace of today’s IT
          Industry. Our employees possess bachelors and advanced degrees in
          relevant fields including Information Technology, Information
          Assurance, Systems Engineering, and Software Development. Our
          technical staff includes numerous Microsoft, Cisco, AWS, CompTIA, and
          other certified professionals. A significant amount of our personnel
          are complaint with DoD 8570.01-M and 8140.01-M Cybersecurity Workforce
          (CSWF).
        </p>
      </div>
      <div className="Careers__body">
        <div className="Careers__body__section why-section">
          <h2 className="section-header">Why Work at PROSOFT?</h2>
          <div className="Careers__body__section__content">
            <h3 className="left-green-border">
              Positive Environments, Professional Opportunites
            </h3>
            <p>
              PROSOFT offers employees an encouraging, engaging work environment
              with every opportunity to expand as professionals.
            </p>
            <p>
              The recruitment, testing and hiring of all personnel will be
              without discrimination against any individual with regard to race,
              color, religion, gender, or national origin. Attempts will be made
              to contact known sources of minority and women potential
              applicants so as to maximize the participation of such applicants.
            </p>
            <p>
              On November 20, 2020, PROSOFT became an approved DOD SkillBridge
              authorized organization with a signed Memorandum of Agreement
              (MOU). The MOU states PROSOFT may accept service members who are
              within 180 days of separating from service and who have completed
              at least 180 days of service into company opportunities for
              training, apprenticeships, or internships. Details about the DOD
              SkillBridge Program can be found at{" "}
              <a href="https://dodskillbridge.usalearning.gov/">
                DOD SkillBridge (usalearning.gov)
              </a>{" "}
              and PROSOFT’s authorization status may be verified here{" "}
              <a href="https://dodskillbridge.usalearning.gov/organizations.htm">
                DOD SkillBridge - Authorized SkillBridge Organizations
                (usalearning.gov)
              </a>
              . As a Military- and Veteran-friendly company, PROSOFT is
              especially proud of this relationship to assist those service
              members transitioning into the commercial workforce. Immediately
              after being authorized, PROSOFT successfully applied the program
              for several service members, helped the members gain approval from
              their service, provided them internships on DOD IT service
              contracts, and subsequently hired the personnel after separation.
              We aspire to keep the trend going and repeat!
            </p>
            <div className="cta-row cta-button-arrow cta-button-arrow-inverse">
              <a href="https://phf.tbe.taleo.net/phf02/ats/careers/searchResults.jsp?org=PROSOFT&cws=41">
                <button>
                  <span>Apply Today</span>
                  <i className="fas fa-arrow-right"></i>
                </button>
              </a>
            </div>
          </div>
          <div className="Careers__body__section__content">
            <h3 className="left-green-border">Hiring America's Veterans</h3>
            <p>
              PROSOFT values the opportunity to hire military veterans and is
              recognized by EGSR’s 5-Star Employer Program. Over thirty percent
              of our workforce has served in the military, including personnel
              currently in the Reserves.
            </p>
            <div className="Careers__images">
              <img
                className="wounded-warrior-img"
                src={WW}
                alt="Wounded Warrior"
              />
              <div className="Careers__images__column">
                <img
                  className="esgr-img"
                  src={ESGR}
                  alt="Employer Support of The Guard and Reserve"
                />
                <img className="hvf-img" src={HVF} alt="Hire Vets First" />
              </div>
            </div>
          </div>
        </div>
        <div className="Careers__body__section hiring-section">
          <h2 className="section-header">Our Hiring Process</h2>
          <div className="Careers__body__section__content">
            <span className="section-number">1</span>
            <h3 className="left-green-border">Application</h3>
            <p>
              You may submit a resume to PROSOFT without specifying a particular
              job. However, applying specifically for one or more positions
              ensures prompt review and consideration, because your resume is
              sent within hours to the recruiter responsible for that position.
            </p>
            <p>
              An online submission of your resume will be acknowledged on
              screen. Resumes submitted by other means will be acknowledged by
              e-mail or postcard. Your profile and resume will remain active in
              our system—which is regularly searched by PROSOFT recruiters—so
              you may be considered for future openings that match your
              qualifications. However, if you desire, we will honor your request
              for removal from further consideration.
            </p>
          </div>
          <div className="Careers__body__section__content">
            <span className="section-number">2</span>
            <h3 className="left-green-border">Timeline</h3>
            <p>
              From the time of your application to our hiring decision, our
              employment process can take from three weeks to three months.
              Because the timing can be unpredictable, you should let your HR
              recruiter know about any factors affecting your availability. If
              you have questions prior to being contacted by HR, you can use the
              "Contact Us" link at the bottom of our Web page. Candidates who
              get to the interview stage will be notified if the position is
              filled by another applicant.
            </p>
          </div>
          <div className="Careers__body__section__content">
            <span className="section-number">3</span>
            <h3 className="left-green-border">Preliminary Screening</h3>
            <p>
              A designated recruiter reviews the qualifications of all
              candidates seeking consideration for a position and forwards the
              resumes of the most appropriately qualified candidates to the
              hiring manager. The hiring manager selects the candidates to be
              interviewed. To help align your interests with our opportunities,
              a PROSOFT representative may call you to ask for additional
              information, such as depth of technical/professional knowledge,
              availability for interviews, interest in relocation, salary
              expectations, etc.
            </p>
          </div>
          <div className="Careers__body__section__content">
            <span className="section-number">4</span>
            <h3 className="left-green-border">Background Checks</h3>
            <p>
              If we are considering you for a job offer, we will conduct a
              background check that covers your employment history, references,
              educational qualifications, etc.
            </p>
          </div>
          <div className="Careers__body__section__content">
            <span className="section-number">5</span>
            <h3 className="left-green-border">Offer</h3>
            <p>
              If you are selected for the position and the background check is
              satisfactory, HR will mail two original offer letters in addition
              to sending an electronic copy via email. Offer acceptance should
              be received via email and followed by a signed original.
            </p>
          </div>
          <div className="Careers__body__section__content">
            <span className="section-number">6</span>
            <h3 className="left-green-border">Hire & Orientation</h3>
            <p>
              After you accept the offer, we will discuss and determine your
              start date. New employees should contact HR to schedule a New Hire
              Orientation.
            </p>
          </div>
        </div>
        <div className="Careers__body__section benefits-section">
          <h2 className="section-header">Employee Benefits</h2>
          <div className="Careers__body__section__content">
            <h3 className="left-green-border">Holidays</h3>
            <p>
              PROSOFT grants 10 paid holidays per year, to all full-time
              employees.
            </p>
          </div>
          <div className="Careers__body__section__content">
            <h3 className="left-green-border">Personal Leave</h3>
            <p>Personal Leave is accrued each bi-weekly pay period.</p>
          </div>
          <div className="Careers__body__section__content">
            <h3 className="left-green-border">Education Assistance</h3>
            <p>
              PROSOFT offers education assistance to employees taking courses or
              obtaining certifications related to their job field. Advance
              approval is required.
            </p>
          </div>
          <div className="Careers__body__section__content">
            <h3 className="left-green-border">Employee Referral Program</h3>
            <p>
              Employee Referral awards of $500 will be paid for all referred
              technical or managerial hires. Referral must be submitted for a
              specific advertised position.
            </p>
          </div>
          <div className="Careers__body__section__content">
            <h3 className="left-green-border">Medical Insurance</h3>
            <p>
              Employees are offered a choice of either aPPO, HDHP, or POS OA
              Plan through Anthem Blue Cross and Blue Shield. For employees
              selecting the HDHP, an accompanying Health Savings Account (HSA)
              is also offered to deduct pre-tax funds to cover the deductible,
              should services be needed beyond preventive care. An HSA balance
              may be carried over year-to-year (no "use or lose" limitation)
              with the earnings free from taxes. The HSA may be used for medical
              expenses through age 65, afterward for medical expenses without
              tax consequence or for any expense that becomes taxable.
            </p>
          </div>
          <div className="Careers__body__section__content">
            <h3 className="left-green-border">TRICARE Supplement</h3>
            <p>
              Designed to pay cost share under the TRICARE "Extra" and TRICARE
              "Standard" options.
            </p>
          </div>
          <div className="Careers__body__section__content">
            <h3 className="left-green-border">Flexible Spending Account</h3>
            <p>
              Allows employees to set-aside pre-tax dollars from pay to pay for
              your portion of the cost of medical insurance, unreimbursed
              medical expenses, and cost of dependent care expenses.
            </p>
          </div>
          <div className="Careers__body__section__content">
            <h3 className="left-green-border">Dental Insurance</h3>
            <p>
              Dental Coverage is through Anthem Dental, to include Diagnostic,
              Preventive, Basic, and Major Services.
            </p>
          </div>
          <div className="Careers__body__section__content">
            <h3 className="left-green-border">Vision Insurance</h3>
            <p>
              Vision insurance is offered through EYEMED , a nationwide carrier,
              for vision exams, lenses, frames, and contact lens benefits and
              Lasik discount.
            </p>
          </div>
          <div className="Careers__body__section__content">
            <h3 className="left-green-border">401(k) Retirement Plan</h3>
            <p>
              The 401k Savings Plan is available to all employees. Employees
              will be eligible for the company match and profit sharing after
              six months of employment.
            </p>
          </div>
          <div className="Careers__body__section__content">
            <h3 className="left-green-border">Life Insurance</h3>
            <p>
              $25,000 term life insurance policy provided by PROSOFT through
              Anthem Life. Supplemental Life Insurance is also available for
              employees and qualifying dependents.
            </p>
          </div>
          <div className="Careers__body__section__content">
            <h3 className="left-green-border">Short Term Disability</h3>
            <p>
              Short Term Disability (STD) is available to employees through
              Anthem Life Insurance. STD begins on the 8th day of illness or
              injury and continues for 12 weeks. The benefit is 67% of your
              weekly salary, not to exceed $1,100 per week, and is paid directly
              to you on a weekly basis.
            </p>
          </div>
          <div className="Careers__body__section__content">
            <h3 className="left-green-border">Long Term Disability</h3>
            <p>
              Long Term Disability (LTD) is provided by PROSOFT through Anthem
              Life Insurance. LTD begins on the 91st day of disability and
              covers 67% of your monthly salary, not to exceed $5,000 per month.
              This benefit is paid directly to you on a monthly basis.
            </p>
          </div>
          <div className="Careers__body__section__content">
            <h3 className="left-green-border">Legal Benefit</h3>
            <p>
              Legal Resources is a benefit provider of legal services. A
              National Law Firm Network is available to handle most of your
              legal needs such as traffic violations, real estate closings, will
              preperation, uncontested divorce problems/child support problems,
              adooptions, credit problems, etc.
            </p>
          </div>
          <div className="Careers__body__section__content">
            <h3 className="left-green-border">Employee Assistance Program</h3>
            <p>
              The Optima Employee Assistance Program, (EAP) puts you in touch
              with a full range of counseling services that address many
              different emotional issues. You and your family can benefit from
              this service, free of charge.
            </p>
          </div>
          <div className="Careers__body__section__content">
            <h3 className="left-green-border">Accident Advantage Plan</h3>
            <p>
              An AFLAC plan that is designed to help cover the expenses
              associated with an accidental injury and pays benefits for
              emergency treatment, initial hospitalization, hospital
              confinement, specific-sum injuries, accidental death, wellness and
              more.
            </p>
          </div>
          <div className="Careers__body__section__content">
            <h3 className="left-green-border">Hospital Advantage Plan</h3>
            <p>
              An AFLAC plan that is designed to help cover the expenses
              associated with annual hospitalization confinement, daily hospital
              confinement, wellness and more.
            </p>
          </div>
          <div className="Careers__body__section__content">
            <h3 className="left-green-border">Cancer Indemnity Plan</h3>
            <p>
              AFLAC plan that pays for first occurrence at diagnosis, hospital
              confinement, radiation, chemotherapy treatment, home health care,
              cancer screenings for wellness benefit, and more.
            </p>
          </div>
          <div className="Careers__body__section__content">
            <h3 className="left-green-border">Pet Insurance</h3>
            <p>
              A discount on Veterinary Pet Insurance helps pay for lab fees,
              treatments, prescriptions, surgery, covering more than 6,400
              medical problems and conditions related to accidents and
              illnesses.
            </p>
          </div>
          <div className="Careers__body__section__content">
            <h3 className="left-green-border">Travelers Accident Insurance</h3>
            <p>
              Covers employees 24 hours while traveling on business away from
              the premises of the Policyholder. Cigna will pay the benefits in
              the policy for any accident, which occurs anywhere in the world
              while a covered person is on a business trip, is traveling or
              making a short stay.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
